export default "__VITE_PUBLIC_ASSET__8b1356a7__"